import { render, staticRenderFns } from "./SetCustomLayout.vue?vue&type=template&id=5256ae8c"
import script from "./SetCustomLayout.vue?vue&type=script&lang=js"
export * from "./SetCustomLayout.vue?vue&type=script&lang=js"
import style0 from "./SetCustomLayout.vue?vue&type=style&index=0&id=5256ae8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports